import { COMPANY, LOGO_URL } from "@/lib/sps-content";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#002438] border-t border-[#8f9194]/15"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          {/* Logo */}
          <div className="md:col-span-3 flex justify-center md:justify-start">
            <img src={LOGO_URL} alt="SPS" className="h-12 w-auto object-contain mix-blend-screen" />
          </div>

          {/* Contact info compact */}
          <ul className="md:col-span-6 grid grid-cols-1 sm:grid-cols-3 gap-3 text-center md:text-left text-xs font-sans-modern text-[#d1d5db]">
            <li className="flex items-center justify-center md:justify-start gap-2">
              <Phone size={12} strokeWidth={1.5} className="text-[#8f9194]" />
              <a href={`tel:${COMPANY.phoneHref}`} className="hover:text-white transition-colors">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-center justify-center md:justify-start gap-2">
              <Mail size={12} strokeWidth={1.5} className="text-[#8f9194]" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors break-all">
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-center justify-center md:justify-start gap-2">
              <MapPin size={12} strokeWidth={1.5} className="text-[#8f9194]" />
              <span>Atotonilco el Alto, Jal.</span>
            </li>
          </ul>

          {/* Socials */}
          <div className="md:col-span-3 flex gap-3 justify-center md:justify-end">
            <a
              href={COMPANY.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-instagram"
              aria-label="Instagram"
              className="h-10 w-10 border border-[#8f9194]/40 flex items-center justify-center text-[#b0b3b8] hover:bg-[#8f9194] hover:text-[#001825] transition-colors"
            >
              <Instagram size={14} strokeWidth={1.5} />
            </a>
            <a
              href={COMPANY.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-facebook"
              aria-label="Facebook"
              className="h-10 w-10 border border-[#8f9194]/40 flex items-center justify-center text-[#b0b3b8] hover:bg-[#8f9194] hover:text-[#001825] transition-colors"
            >
              <Facebook size={14} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-[#8f9194]/15 text-center">
          <p className="text-[11px] text-[#8f9194] font-sans-modern tracking-[0.15em]">
            SPS {year}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
